import AppListing from '../app-components/Listing/AppListing';
import LogDetail from '../app-components/log-detail.vue'

Vue.component('logs-transaction-listing', {
    
    mixins: [AppListing],
    components: {
        LogDetail,
      },
    data: function() {
        return {
            detailLog: {
                old:{},
                new:{},
            },
            moduleFilters:{
                date_start: null,
                date_end: null,
                app_offices_id: null, 
                table_name: null
            },
            orderBy: {
                column: 'logs_transaction.id',
                direction: 'desc'
            },
            customParam: {
                parentId: null,
                desc: null,
                item: {}
            },
            tempFactory: null
        }
    },
    methods: {
        beforeOpen (event) {
          console.log(event.params.foo);
        },
        openDialog(){
            this.$modal.show('dialog', {
                title: 'Warning!',
                text: 'Do you really want to delete this item?',
                buttons: [
                    { title: 'No, cancel.' },
                    {
                        title: '<span class="btn-dialog btn-danger">Yes, delete.<span>',
                        handler: () => {
                            this.$modal.hide('dialog');
                            console.log('deleted');
                        }
                    }
                ]
            });
        },
        openDetail(data) {
            this.detailLog.new = data.new_value
            this.detailLog.old = data.old_value
            this.$modal.show('detail-log', {
                detailLog: data
            })
        },
        beforeOpenDetailLog (event) {
            // console.log("beforeOpenDetailLog",event.params);
        },
        detailLogClose(){
            this.$modal.hide('detail-log')
        },
        loadData: function loadData(resetCurrentPage) {
            var _this6 = this;

            if (this.customParam.parentId) {
                this.pagination.state.per_page = 300
                this.pagination.state.current_page = 0
            }

            var options = {
                params: {
                    per_page: this.pagination.state.per_page,
                    page: this.pagination.state.current_page,
                    orderBy: this.orderBy.column,
                    orderDirection: this.orderBy.direction,
                    parent_id: _this6.customParam.parentId,
                    // app_offices_id: _this6.moduleFilters.app_offices_id,
                    
                }
            };

            if (resetCurrentPage === true) {
                options.params.page = 1;
            }
           

            Object.assign(options.params, this.filters);
            Object.assign(options.params, this.moduleFilters);

            axios.get(this.url, options).then(function (response) {
                _this6.countResult = response.data.count;
                // const { calculated } = response.data
                // _this6.calculated = {
                //     financial_total : calculated.financial_total||[],
                //     total: calculated.total||0
                // };
                // _this6.financialBalance = response.data.financialBalance;
                // _this6.buildUrlPayment()
                // _this6.buildUrlDownloadFinanceReport()
                return _this6.populateCurrentStateAndData(response.data.data);
            }, function (error) {
                // TODO handle error
            });
        },
        filterParentId(item){
            // this.customParam.parentId=item.parent_id;
            console.log('item', item)
            if (item) {
                this.customParam.parentId=item.parent_id || item.id;
                this.customParam.desc=item.desc;
                this.customParam.item=item;
            }else{
                this.customParam.parentId=null;
                this.customParam.desc=null;
                this.customParam.item={};
                this.pagination.state.per_page = 10
                this.pagination.state.current_page = 1
            }
            this.loadData();
        },
        onSelectFactory(factory){
            this.moduleFilters.app_offices_id = factory.id
            this.loadData();
        },
        onRemoveFactory(){
            this.moduleFilters.app_offices_id =  null
            this.loadData();
        },
        onSelectTable(table_name){
            this.moduleFilters.table_name =  table_name
            this.loadData();
        },
        onRemoveTable(){
            this.moduleFilters.table_name =  null
            this.loadData();
        },
    }
});